export default __webpack_public_path__ + "static/media/css-logo.a94f84e0.png";